/**
 * Versions state
 */
import { ActionTree, GetterTree, MutationTree } from 'vuex';

import { IVersionsStoreState } from '../@types';
import { getVersionConfig } from '../services/versions.helpers';

/**
 * State
*/
const state: IVersionsStoreState = {
    appVersion: getVersionConfig()
}

/**
 * Mutations
 */
 const mutations: MutationTree<IVersionsStoreState> = {
	updateAppVersion (stateObj: IVersionsStoreState, appVersion: string) {
		stateObj.appVersion = appVersion;
	}
};

/**
 * Getters
 */
const getters: GetterTree<IVersionsStoreState, any> = {
    get_appVersion (stateObj: IVersionsStoreState): string {
        return stateObj.appVersion;
    }
}

/**
 * Actions
 */
 const actions: ActionTree<IVersionsStoreState, any> = {
	axn_updateAppVersion (context: any, appVersion: string) {
		context.commit('updateAppVersion', appVersion);
	}
};

/**
 * Export
 */
export default {
    state,
    mutations,
    getters,
    actions
}